<template>
    <el-dialog v-model="open" width="800px">
        <template #header> 添加回复</template>
        <template #footer>
            <el-button key="back" @click="handleCandel">取消</el-button>
            <el-button key="submit" type="primary" @click="handleSubmit">确定</el-button>
        </template>
        <div>
            <div class="content_area m_border_1" style="height: 150px;">
                <textarea ref="editorRef" @blur="handleSaveFocusIndex" v-model="contentRef" name="textarea"
                    style="width: 100%; height: 100%; border: none; resize: none" maxlength="100"></textarea>
            </div>
            <faceselect ref="faceSelectRef" @selectedIcon="handleSelectIcon" />
        </div>
    </el-dialog>

</template>

<script>
import { reactive, ref, computed, inject } from 'vue';
import faceselect from "@/components/face-select/index.vue";
import { ElMessage } from "element-plus";
export default {
    props: {
        nullable: {
            type: Boolean,
            default: false
        },
    },
    emits: ["contentResult"],
    components: { faceselect },
    setup(props, { emit, expose }) {
        // --------------- props ----------------

        const open = ref(false)
        const contentRef = ref('')
        const editorRef = ref(undefined)
        const faceSelectRef = ref(undefined);

        const replyContentCursorIdx = ref(0);
        const plat_type_ref = inject("chatingPlatId")
        const echoRef = ref(undefined);
        const faceSelectVisiable = ref(false)
        // --------------- 方法 --------------
        const handleSubmit = async () => {
            if (!props.nullable && !contentRef.value) {
                ElMessage.error('回复内容不能为空')
                return
            }
            emit('contentResult', { content: contentRef.value, echo: echoRef.value })
            open.value = false
        }
        const handleCandel = () => {
            open.value = false
        }

        const handleShowFace = async () => {
            faceSelectRef.value.show(plat_type_ref.value)
        }

        const show = async (plat_type, echo) => {
            // console.log("--------",plat_type,echo)
            // plat_type_ref.value = plat_type || -1
            echoRef.value = echo
            open.value = true
            contentRef.value = ''
            replyContentCursorIdx.value = 0;
        }

        const handleSelectIcon = (result) => {
            let { title, echo } = result
            faceSelectVisiable.value = false;
            let factStr = `[${title}]`;

            let content = contentRef.value;
            if (content) {
                // let oldContentLength = content.length;
                content = `${content.substring(0, replyContentCursorIdx.value)}${factStr}${content.substring(replyContentCursorIdx.value)}`;
                replyContentCursorIdx.value += factStr.length;
            } else {
                content = factStr;
                replyContentCursorIdx.value += content.length;
            }
            contentRef.value = content;
        };

        const handleSaveFocusIndex = () => {
            replyContentCursorIdx.value = editorRef.value.selectionStart;
        };

        expose(
            { show }
        )
        return {
            open,
            contentRef,
            editorRef,
            faceSelectRef,
            faceSelectVisiable,
            plat_type_ref,
            show,
            handleSubmit,
            handleCandel,
            handleShowFace,
            handleSelectIcon,
            handleSaveFocusIndex
        }

    }
}
</script>